const initRaffleMerchant = {
  raffleMerchants: [],
  currentPage: 1,
  totalPage: 1,
  limitPage: 10,
  lengthPage: 1,
  searchValue: "",
  filterCityPage: "",
};

export const raffleMerchantReducer = (
  state = initRaffleMerchant,
  action: any
) => {
  if (action.type === "SET_RAFFLE_MERCHANT") {
    return {
      ...state,
      raffleMerchants: action.value,
    };
  }
  if (action.type === "SET_RAFFLE_MERCHANT_CURRENT_PAGE") {
    return {
      ...state,
      currentPage: action.currentPage,
    };
  }
  if (action.type === "SET_RAFFLE_MERCHANT_PAGE") {
    return {
      ...state,
      totalPage: action.totalPage,
      limitPage: action.limitPage,
      lengthPage: action.lengthPage,
    };
  }
  if (action.type === "SET_SEARCH_RAFFLE_MERCHANT") {
    return {
      ...state,
      searchValue: action.searchValue,
    };
  }
  if (action.type === "SET_RAFFLE_MERCHANT_FILTER_PAGE") {
    return {
      ...state,
      filterCityPage: action.filterCityPage,
    };
  }
  return state;
};
